export const nl: Record<string, string> = {
  // Menu
  'menu.subtitle': 'Een blokkenwereld avontuur',
  'menu.playerName': 'Speler naam',
  'menu.namePlaceholder': 'Voer je naam in...',
  'menu.play': 'Spelen',
  'menu.footer': 'v0.3 — Multiplayer · <a href="/stats" id="stats-link">Server stats</a>',
  'menu.blogPill': '\u{1F4DD} Making-of blogpost',
  'menu.online.none': 'Geen spelers online',
  'menu.online.one': '1 speler online',
  'menu.online.many': '{count} spelers online',
  'menu.defaultName': 'Speler',

  // Character customizer
  'customizer.type': 'Type',
  'customizer.hair': 'Haar',
  'customizer.skin': 'Huid',
  'customizer.shirt': 'Shirt',
  'customizer.pants': 'Broek',
  'customizer.shoes': 'Schoenen',

  // Controls
  'controls.move': 'Bewegen',
  'controls.jump': 'Springen',
  'controls.sprint': 'Rennen',
  'controls.look': 'Kijken',
  'controls.break': 'Breken',
  'controls.place': 'Plaatsen',
  'controls.selectBlock': 'Blok kiezen',
  'controls.inventory': 'Inventaris',
  'controls.craft': 'Craften',
  'controls.mute': 'Geluid uit',
  'controls.lighting': 'Verlichtingsmodus wisselen',
  'controls.chat': 'Chat',
  'controls.playerList': 'Spelerlijst',

  // Player list
  'playerList.title': 'Spelers Online',
  'playerList.name': 'Naam',
  'playerList.position': 'Positie',
  'playerList.you': 'jij',
  'playerList.count': '{count} spelers online',

  // HUD
  'hud.oxygen': 'Lucht',
  'hud.players': 'Spelers: {count}',
  'hud.position': 'Positie: {x}, {y}, {z}',

  // Death screen
  'death.title': 'Je bent verdronken!',
  'death.respawn': 'Klik om te herleven',

  // World selector
  'world.choose': 'Kies een Wereld',
  'world.players': '{count}/{max} spelers',
  'world.play': 'Speel',
  'world.password': 'Wachtwoord:',
  'world.ok': 'OK',
  'world.cancel': 'Annuleer',

  // Chat / network
  'chat.placeholder': 'Typ een bericht...',
  'chat.playerJoined': '{name} is verbonden',
  'chat.disconnected': 'Verbinding verbroken!',
  'chat.reconnecting': 'Opnieuw verbinden in {seconds}s... (poging {attempt})',
  'chat.reconnected': 'Nieuwe versie van de server, opnieuw verbonden!',
  'net.connecting': 'WS: verbinden...',
  'net.connected': 'WS: verbonden',
  'net.disconnected': 'WS: verbroken',
  'net.notConnected': 'WS: niet verbonden',
  'net.status': 'WS: verbonden ({id}) | Chunks: {chunks} | Blk: {sent}/{recv}',

  // Crafting / Inventory
  'crafting.inventory': 'Inventaris',
  'crafting.furnace': 'Oven',
  'crafting.workbench': 'Werktafel',
  'crafting.crafting': 'Craften',
  'crafting.hint': 'Klik op een voorwerp om het in slot {slot} te plaatsen',
  'crafting.recipeBook': 'Receptenboek',
  'crafting.items': 'Voorwerpen',

  // Help screen
  'help.title': 'Hulp',
  'help.resources': 'Grondstoffen',
  'help.controls': 'Besturing',
  'help.recipes': 'Recepten',
  'help.closeHint': 'Druk H of Esc om te sluiten',
  'help.helpKey': 'Hulpscherm',
  'help.close': 'Sluiten',
  'help.keySpace': 'Spatie',
  'help.keyMouse': 'Muis',
  'help.ores': 'Ertsen & Mineralen',
  'help.coal': 'Overal ondergronds, meest bovenaan (y 140+)',
  'help.iron': 'Middeldiep (y 80-140), ook dieper',
  'help.gold': 'Diep (y 30-80), zeldzaam',
  'help.diamond': 'Zeer diep (y < 60), meest onder y 30',
  'help.obsidian': 'Diepste laag (y < 30), bij lava',
  'help.biomes': 'Biomen',
  'help.forest': 'Eiken, paddestoelen, bloemen',
  'help.desert': 'Zand, zandsteen, cactussen',
  'help.tundra': 'Sneeuw, ijs, sparren',
  'help.swamp': 'Donker gras, klei, lianen',
  'help.mountains': 'Zeer hoog, sneeuwtoppen, steen',
  'help.special': 'Speciale Blokken',
  'help.flyblock': 'Springblok — stuitert je hoog de lucht in',
  'help.superflyblock': 'Super springblok — 3x zo hoog als vliegblok',
  'help.portal': 'Bouw twee 3x4 frames, ze koppelen automatisch. Loop erdoor om te teleporteren!',
  'help.lava': 'Doet schade! Gevonden in grotten onder y 50',
  'help.water': 'Oceanen, meren, vertraagt beweging',
  'help.bed': 'Slaap door de nacht! Alle spelers moeten in bed liggen.',
  'help.speedblock': 'Geeft 5 seconden superspeed wanneer je erop loopt!',
  'help.ice': 'Glad oppervlak — je glijdt door!',
  'help.arrowblock': 'Duwt je in de richting van de pijl!',
  'help.launchpad': 'Lanceert je ver door de lucht! Dure maar krachtige reis.',
  'help.paintblocks': 'Loop erdoor voor kleurrijke voetstappen (30 seconden)',
  'help.musicblock': 'Klik rechts om noten te spelen! 8 tonen (C-C).',
  'help.firework': 'Klik rechts om vuurwerk af te schieten! Wordt verbruikt.',
  'help.teleportblock': 'Stap erop om naar een willekeurige speler te teleporteren!',
  'help.tnt': 'Sla erop om de lont aan te steken. Ontploft na 3 seconden!',

  // Sleep
  'sleep.sleeping': 'Slapen...',
  'sleep.playerCount': '{sleeping}/{total} spelers slapen',
  'sleep.wakeHint': 'Klik om wakker te worden',
  'sleep.notNight': "Je kunt alleen 's nachts slapen!",

  // Mobile
  'mobile.rotate': 'Draai je scherm voor de beste ervaring',

  // Admin page
  'admin.title': 'JanneCraft Admin',
  'admin.subtitle': 'Beheerder Paneel',
  'admin.password': 'Wachtwoord',
  'admin.login': 'Inloggen',
  'admin.back': '← Terug naar JanneCraft',
  'admin.play': 'Speel',
  'admin.stats': 'Stats',
  'admin.admin': 'Admin',
  'admin.logout': 'Uitloggen',
  'admin.serverOverview': 'Server Overzicht',
  'admin.playersOnline': 'Spelers Online',
  'admin.worlds': 'Werelden',
  'admin.uptime': 'Uptime',
  'admin.createWorld': 'Nieuwe Wereld Aanmaken',
  'admin.name': 'Naam',
  'admin.seedOptional': 'Seed (optioneel)',
  'admin.seedPlaceholder': 'Willekeurig',
  'admin.passwordOptional': 'Wachtwoord (optioneel)',
  'admin.passwordPlaceholder': 'Geen',
  'admin.maxPlayers': 'Max Spelers',
  'admin.create': 'Maak Aan',
  'admin.worldList': 'Werelden',
  'admin.players': 'Spelers',
  'admin.status': 'Status',
  'admin.seed': 'Seed',
  'admin.actions': 'Acties',
  'admin.loading': 'Laden...',
  'admin.noWorlds': 'Geen werelden',
  'admin.onlinePlayers': 'Online Spelers',
  'admin.playerName': 'Naam',
  'admin.world': 'Wereld',
  'admin.position': 'Positie',
  'admin.noPlayers': 'Geen spelers online',
  'admin.backToGame': 'Terug naar JanneCraft',
  'admin.delete': 'Verwijder',
  'admin.default': 'Standaard',
  'admin.confirmDelete': 'Weet je zeker dat je "{name}" wilt verwijderen?<br>Dit kan niet ongedaan worden!',
  'admin.error': 'Fout',
  'admin.connectionFailed': 'Verbinding mislukt',
  'admin.myWorld': 'Mijn Wereld',
  'admin.none': 'Geen',
  'admin.badge.default': 'standaard',
  'admin.badge.locked': 'slot',
  'admin.badge.loaded': 'geladen',
  'admin.badge.unloaded': 'niet geladen',
  'admin.size': 'Grootte',
  'admin.chunks': 'chunks',
  'admin.mods': 'wijzigingen',
  'admin.uniquePlayers': 'Unieke Spelers',
  'admin.allPlayers': 'Alle Spelers',
  'admin.lastWorld': 'Laatste Wereld',
  'admin.uuid': 'UUID',
  'admin.noPlayersEver': 'Nog geen spelers',

  // Stats page
  'stats.title': 'JanneCraft',
  'stats.serverStatus': 'Server Status',
  'stats.playersOnline': 'Spelers Online',
  'stats.connecting': 'Verbinden...',
  'stats.noPlayers': 'Geen spelers online',
  'stats.uptime': 'Uptime',
  'stats.days': 'dagen',
  'stats.hours': 'uur',
  'stats.minutes': 'min',
  'stats.seconds': 'sec',
  'stats.dayNight': 'Dag / Nacht Cyclus',
  'stats.sunrise': 'Zonsopgang',
  'stats.day': 'Dag',
  'stats.sunset': 'Zonsondergang',
  'stats.night': 'Nacht',
  'stats.world': 'Wereld',
  'stats.chunksLoaded': 'Chunks Geladen',
  'stats.worlds': 'Werelden',
  'stats.worldPlayers': '{count}/{max} spelers',
  'stats.playGame': 'Speel JanneCraft',
  'stats.performance': 'Server Prestaties',
  'stats.memoryUsage': 'Geheugen (MB)',
  'stats.wsMessages': 'WebSocket Berichten/s',
  'stats.wsIn': 'In',
  'stats.wsOut': 'Uit',
  'stats.loadedChunks': 'Geladen Chunks',
  'stats.loadedWorlds': 'Geladen Werelden',
  'stats.rss': 'RSS',
  'stats.heap': 'Heap',

  // Block names (block.ID)
  'block.0': 'Lucht',
  'block.1': 'Gras',
  'block.2': 'Aarde',
  'block.3': 'Steen',
  'block.4': 'Zand',
  'block.5': 'Hout',
  'block.6': 'Bladeren',
  'block.7': 'Water',
  'block.8': 'Kasseien',
  'block.9': 'Planken',
  'block.10': 'Glas',
  'block.11': 'Baksteen',
  'block.12': 'Sneeuw',
  'block.13': 'Bloem',
  'block.14': 'Steenkoolerts',
  'block.15': 'IJzererts',
  'block.16': 'Gouderts',
  'block.17': 'Diamanterts',
  'block.18': 'Bodemsteen',
  'block.19': 'Stok',
  'block.20': 'Fakkel',
  'block.21': 'IJzerstaaf',
  'block.22': 'Goudstaaf',
  'block.23': 'Diamant',
  'block.24': 'Werktafel',
  'block.25': 'Oven',
  'block.26': 'Houten Houweel',
  'block.27': 'IJzeren Houweel',
  'block.28': 'Steenkool',
  'block.29': 'Zandsteen',
  'block.30': 'IJs',
  'block.31': 'Cactus',
  'block.32': 'Paddenstoel',
  'block.33': 'Lang Gras',
  'block.34': 'Sparrenhout',
  'block.35': 'Sparrenbladeren',
  'block.36': 'Berkenhout',
  'block.37': 'Berkenbladeren',
  'block.38': 'Donker Gras',
  'block.39': 'Liaan',
  'block.40': 'Lava',
  'block.41': 'Grind',
  'block.42': 'Obsidiaan',
  'block.43': 'Klei',
  'block.44': 'Vliegblok',
  'block.45': 'Supervliegblok',
  'block.46': 'Portaalsteen',
  'block.47': 'Portaalvlak',
  'block.48': 'Bed',
  'block.49': 'Bedhoofd',
  'block.50': 'Springplank',
  'block.51': 'Verfblok Rood',
  'block.52': 'Verfblok Blauw',
  'block.53': 'Verfblok Groen',
  'block.54': 'Verfblok Geel',
  'block.55': 'Pijlblok',
  'block.56': 'Pijlblok Oost',
  'block.57': 'Pijlblok Zuid',
  'block.58': 'Pijlblok West',
  'block.59': 'Muziekblok',
  'block.60': 'Teleporteerblok',
  'block.61': 'Explosiefblok',
  'block.62': 'Vuurwerk',
  'block.63': 'Snelheidsblok',

  // Model types (model.ID)
  'model.0': 'Jongen',
  'model.1': 'Meisje',
  'model.2': 'Robot',
  'model.3': 'Skelet',
  'model.4': 'Alien',
  'model.5': 'Pompoen',
  'model.6': 'Ninja',
};
